import React from 'react';
import { useAuth } from '../../hooks/useAuth';

function normalizeName(x) {
  if (!x) return '';
  if (typeof x === 'string') return x.trim().toLowerCase();
  if (typeof x === 'object' && x.name != null) return String(x.name).trim().toLowerCase();
  return String(x).trim().toLowerCase();
}

function collectUserPermissions(user) {
  // Soporta distintas formas:
  // - user.permissions => ['a:b:c'] o [{name:'a:b:c'}]
  // - user.roles[].permissions => idem
  // - user.data.roles (por compat)
  const perms = [];

  // 1) permisos directos en user
  if (Array.isArray(user?.permissions)) {
    for (const p of user.permissions) perms.push(normalizeName(p));
  }

  // 2) permisos vía roles (user.roles o user.data.roles)
  const roles =
    Array.isArray(user?.roles) ? user.roles :
    Array.isArray(user?.data?.roles) ? user.data.roles :
    [];

  for (const role of roles) {
    if (Array.isArray(role?.permissions)) {
      for (const p of role.permissions) perms.push(normalizeName(p));
    }
  }

  // Evitar duplicados
  return Array.from(new Set(perms));
}

export function hasAllPermissions(userPerms, required = []) {
  if (!required?.length) return false; //si no especifica el atributo permissions, retornamos false.
  const set = new Set((userPerms ?? []).map(normalizeName));
  return required.every((p) => set.has(normalizeName(p)));
}

/**
 * Props:
 *  - permissions: string | string[]
 *  - fallback?: ReactNode
 *  - showWhileLoading?: ReactNode
 */
export function RequirePermission({
  permissions,
  fallback = null,
  showWhileLoading = null,
  children,
}) {
  const { user, loading } = useAuth();

  if (loading) {
    return showWhileLoading !== null ? <>{showWhileLoading}</> : null;
  }

  const required = Array.isArray(permissions) ? permissions : permissions ? [permissions] : [];
  const userPermissions = collectUserPermissions(user);
  const ok = hasAllPermissions(userPermissions, required);

  return <>{ok ? children : fallback}</>;
}